(function() {
    const SceltaUtenzaService = function(
        $http,
        CONSTANTS
    ) {
        this.ndg = '00';

        this.openLista = () => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.LISTA + this.ndg
            });
        };
        
        this.recuperaTuttiStati = () => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.LISTA_TUTTI_STATI
            });
        };

        this.recuperaConfigurazioni = (tipoPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI.CONFIGURAZIONI + tipoPratica
            });
        };
    };

    SceltaUtenzaService.$inject = [
        '$http',
        'Mitom_CONSTANTS'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomSceltaUtenzaService', SceltaUtenzaService);
})();